
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';

// below is now in /store.index.js
//import Vuex from 'vuex';
//Vue.use(Vuex);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import store from './store/index'; //
import DeleteModal from './components/DeleteModal.vue';
import CheckboxToggle from './components/form/CheckboxToggle.vue';
import SetOptionsFilter from './components/form/SetOptionsFilter.vue';
import AutocompleteTag from './components/AutocompleteTag.vue';

const app = new Vue({
    el: '#app',
    store, // inject store to all children
    components: {
        CheckboxToggle,
        DeleteModal,
        SetOptionsFilter,
        AutocompleteTag
    },
    data: {
        showModal: false,
        isHidden: true,
        showImage:true,
        showFile:true,
        showImageFile:true,
        appUrl:Laravel.appUrl,
        showDateRange: document.getElementById('has_date_range_1') ? document.getElementById('has_date_range_1').checked : false
    },
     methods: {
         toggleShow(){
            return !this.isHidden;
        },
        dateRangeToggle(){
            $('#start_date').datepicker();
            $('#start_date_time').timepicker();
            $('#end_date').datepicker();
            $('#end_date_time').timepicker();
            return !this.showDateRange;
        },
     },
    computed: {

    }
});
